export const gaEvent = {
  methods: {
    googleManagerCreateAccount(type) {
      console.log('tracking manager create account ' + type);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'create-account',
        'registration-type': type, // Replace TYPE with form, twitch, twitter, youtube, mixer, etc (depending on thow they signed up)
      });
    },
    googleManagerLogin(type) {
      console.log('tracking manager account login ' + type);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'account-signin',
        'registration-type': type, // Replace TYPE with form, twitch, twitter, youtube, mixer, etc (depending on thow they signed up)
      });
    },
    googleManagerRegisterEvent(event, eventDetail) {
      console.log('tracking manager register event ' + event);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'event-signup',
        'event-name': event, // Replace NAME OF EVENT with the actual event name
        // 'event-detail1': eventDetail,          //OPTIONAL - if any other event data should be passed through. Add it to event-details 1-3 OR delete if not needed
      });
    },
    gleamTrackingRegisterIntel(userId, email, type) {
      if (typeof type === 'undefined') {
        type = 'registerNow';
      }

      if (typeof Gleam !== 'undefined') {
        if (email) {
          console.log('tracking gleam push ' + type + ' email ' + email);
          // eslint-disable-next-line no-undef
          Gleam.push([type, email]);
        } else {
          console.log('tracking gleam push ' + type + ' user id ' + userId);
          // eslint-disable-next-line no-undef
          Gleam.push([type, userId]);
        }
      }
    },
    gleamTrackingJoinVerizonHub(email) {
      if (typeof Gleam !== 'undefined') {
        console.log('gleamTrackingJoinVerizonHub push BoomTV email ' + email);
        // eslint-disable-next-line no-undef
        Gleam.push(['JoinVerizonHub', email]);
      }
    },
    gleamTrackingJoinHub(email) {
      if (typeof Gleam !== 'undefined') {
        console.log('gleamTrackingJoinHub push BoomTV email ' + email);
        // eslint-disable-next-line no-undef
        Gleam.push(['UserEmail', email]);
      }
    },
    twitterTrackingOrderSuccess() {
      if (window.twttr) {
        window.twttr.conversion.trackPid('o5axg', { tw_sale_amount: 0, tw_order_quantity: 0 });
      }
    },
    twitterTrackingCreateAccount() {
      if (window.twttr) {
        window.twttr.conversion.trackPid('o5axi', { tw_sale_amount: 0, tw_order_quantity: 0 });
      }
    },
    facebookTrackingOrderSuccess() {
      if (typeof fbq === 'function') {
        // eslint-disable-next-line no-undef
        fbq('track', 'Purchase', { value: '0.00', currency: 'USD' });
      }
    },
  },
};
